import classNames from "classnames";
import CloseIcon from "PFIcons/close.svg";
import EditIcon from "PFIcons/edit.svg";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import css from "./edit_link.less";

const EditLink = ({ section, style, isEditMode, onClick, className }) => {
  const url = section ? `/profile/edit/${section}` : null;
  const icon = isEditMode ? <CloseIcon width={16} height={16} /> : <EditIcon width={12} height={12} />;
  const Tag = section ? Link : "button";

  return (
    <Tag to={url} style={style} className={classNames(css.editLink, className)} onClick={onClick}>
      {icon}
    </Tag>
  );
};

EditLink.propTypes = {
  section: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  isEditMode: PropTypes.bool,
  className: PropTypes.string
};

EditLink.defaultProps = {
  isEditMode: false
};

export default EditLink;
